<div class="notifications">
  <div *ngFor="let notification of notifications" (mouseenter)="mouseEnter(notification)" (mouseleave)="mouseLeave(notification)" class="notification"
    [ngClass]="'notification-' + notification.type" [class.removed]="notification.hidden">
    <div class="notification-icon">
      <i [ngClass]="notification.icon"></i>
    </div>
    <div class="notification-container">
      <span class="notification-close icon-close" (click)="remove(notification, true)"></span>
      <div *ngIf="notification.title" class="notification-title">
        {{ notification.title }}
        <span *ngIf="notification.type !== 'success' && notification.channel === 'proxy'" class="tags">
          <span class="tag">{{ notification.channel }}</span>
        </span>
      </div>
      <div class="notification-content" [innerHTML]="notification.content"></div>
    </div>
  </div>
</div>
